/**
 * KOI相关路由配置
 */
const koiRoutes = [
  {
    path: '/koi',
    name: 'Koi',
    component: () => import('@/views/koi/KoiView.vue'),
    meta: {
      title: 'KOI',
      requireAuth: false,
      hideNav: true
    }
  },
  {
    path: '/koi/gift-record',
    name: 'KoiGiftRecord',
    component: () => import('@/views/koi/KoiGiftRecordView.vue'),
    meta: {
      title: 'KOI赠送记录',
      requireAuth: false,
      hideNav: true
    }
  },
  {
    path: '/koi/digital-brand-gift-record',
    name: 'DigitalBrandGiftRecord',
    component: () => import('@/views/koi/DigitalBrandGiftRecordView.vue'),
    meta: {
      title: '锦鲤品牌权益卡・赠送记录',
      requireAuth: false,
      hideNav: true
    }
  },
  {
    path: '/koi/invite-level-gift-record',
    name: 'InviteLevelGiftRecord',
    component: () => import('@/views/koi/InviteLevelGiftRecordView.vue'),
    meta: {
      title: '网点邀请权益・赠送记录',
      requireAuth: false,
      hideNav: true
    }
  },
  {
    path: '/koi/koi-league-gift-record',
    name: 'KoiLeagueGiftRecord',
    component: () => import('@/views/koi/KoiLeagueGiftRecordView.vue'),
    meta: {
      title: '锦鲤联盟权益-赠送记录',
      requireAuth: false,
      hideNav: true
    }
  },
  {
    path: '/koi/card-merchant-gift-record',
    name: 'CardMerchantGiftRecord',
    component: () => import('@/views/koi/CardMerchantGiftRecordView.vue'),
    meta: {
      title: '卡商邀请权益-赠送记录',
      requireAuth: false,
      hideNav: true
    }
  }
]

export default koiRoutes